import Modal from '../../components/modal.js';

class PreviewFile {
  constructor() {
    this.modals = {};
  }

  get dom() {
    return {
      HIERARCHY_FIELD_ACTIONS: '.hierarchy-field-actions',
      HIERARCHY_FIELD_PREVIEW_TYPE: '#hierarchy_preview_file_type',
    };
  }

  showXMLModal(e, data = undefined) {
    let params = data || this._buildParams(e),
      self = this;

    e.preventDefault();
    if (!params) {
      return;
    }

    $.ajax({
      data: params,
      url: `${location.protocol}//${location.host}${location.pathname}/template_file`,
    }).done((response) => {
      response.contents = $('<div>').text(response.contents).html();
      self._destroyModals();
      self
        ._createModal(
          'site-xml',
          JST['templates/stores/template_preview']({ data: response }),
        )
        .show();
    });
  }

  _createModal(id, content) {
    const modal =
      this.modals[id] || (this.modals[id] = new Modal({ id: id, wait: true }));

    modal.setContent(content);
    prettyPrint();
    return modal;
  }

  _destroyModals() {
    Object.values(this.modals).forEach((modal) => modal.destroy());
    this.modals = {};
  }

  _shouldUseOriginalTemplateFile(sourceId) {
    return (
      sourceId === 'rts_preview_file' ||
      (sourceId === 'preview_file' && this._isStoreIndex())
    );
  }

  _isStoreIndex() {
    return $("[name='store_id']").val() === undefined;
  }

  _buildParams(e) {
    let source = $(`#${$(e.target).attr('rel')}`),
      owner = source.find(`option[value="${source.val()}"]`).attr('rel');

    if (source.find(':selected').val() === undefined) {
      return;
    }
    return {
      owner_type: source.attr('rel'), // eslint-disable-line camelcase
      owner_id: owner, // eslint-disable-line camelcase
      global: source.find(':selected').data('global') || false,
      filename: source.find(':selected').val(),
      original_file: this._shouldUseOriginalTemplateFile(source.prop('id')), // eslint-disable-line camelcase
    };
  }
}

module.exports = PreviewFile;
